import styled from 'styled-components';

export const MenuIcon = styled.span`
	position: relative;
	top: 15%;
`;

export const MenuTitle = styled.span`
	margin-left: 10px;
`;
